import { TextFieldProps, Grid, Divider, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { RequiredIcon } from '@vayufp/coast-components';
import React from 'react';

type Props = React.PropsWithChildren<{
  id: TextFieldProps['id'];
  labelId?: TextFieldProps['id'];
  label: TextFieldProps['label'];
  disableBottomBorder?: boolean;
  isHeading?: boolean;
  asterisk?: boolean;
}>;

const headingSx: SxProps<Theme> = ({ spacing }) => ({
  minHeight: spacing(10),
});

const normalSx: SxProps<Theme> = ({ spacing }) => ({
  py: 1,
  minHeight: spacing(8),
});

const requiredAsterisk = (
  <Typography variant="inherit" component="span" color="required.main" pl={1}>
    <RequiredIcon style={{ width: '7', height: '15' }} fill="currentColor" />
  </Typography>
);

const RowFieldBase: React.FC<Props> = (props: Props) => {
  const { id, labelId, label, disableBottomBorder, isHeading, children, asterisk } = props;

  const rootSx = isHeading ? headingSx : normalSx;

  return (
    <>
      <Grid role="group" container alignItems="center" sx={rootSx}>
        <Grid item xs={12} md={6} lg={4} component="label" htmlFor={id} id={labelId}>
          <Typography
            component="span"
            variant={isHeading ? 'body2' : 'inherit'}
            color={isHeading ? undefined : 'text.secondary'}
          >
            {label}
          </Typography>
          {asterisk ? requiredAsterisk : ''}
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          {children}
        </Grid>
      </Grid>
      {!disableBottomBorder && <Divider />}
    </>
  );
};

export { RowFieldBase };
